import styled from '@emotion/styled'
import { wrap as withStyle, stylesIf, themeColor } from 'utils/styles'
import { Row, Checkbox, Flex } from 'components/patterns'
import { PagedTable } from 'components/chec'

const SEARCH_SIDEBAR_WIDTH = 295

export default withStyle((props) => {
  const { hasSidebar } = props
  const sideBarStyle = `
    display: flex;
    flex-direction: row;
  `
  return `
    ${stylesIf(hasSidebar, sideBarStyle)}
  `
})

export const SearchForm = styled.div((props) => {
  const { hasSidebar } = props
  return stylesIf(
    hasSidebar,
    `
    width: ${SEARCH_SIDEBAR_WIDTH}px;
    min-width: ${SEARCH_SIDEBAR_WIDTH}px;
    margin-right: 16px;
  `
  )
})

export const StyledPagedTable = styled(PagedTable)`
  && .ant-table-placeholder {
    white-space: break-spaces;
  }
  &&.new-search {
    table {
      table-layout: fixed;
      width: 100%;
    }
  }
  &&.add-feature-search {
    margin-left: 0px;
    table {
      table-layout: fixed;
      width: 100%;
    }
  }

  /* Selected row styling - matches Figma design */
  && .ant-table-tbody > tr.selected > td {
    background-color: ${themeColor('blueLight')};
  }

  /* Checkbox styling - matches Figma colors */
  && .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${themeColor('tableCheckboxChecked')};
    border-color: ${themeColor('tableCheckboxChecked')};
  }

  && .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${themeColor('tableCheckboxChecked')};
  }

  && .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  && .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${themeColor('tableCheckboxHover')};
  }

  /* Disabled checkbox styling for ineligible features */
  && .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: ${themeColor('greySecondary')};
    border-color: ${themeColor('tableCheckboxInner')};
  }
`

export const SearchFormRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 25px;
  justify-content: center !important;
`

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 30px;

  &.ant-checkbox-wrapper {
    color: rgba(7, 7, 15, 0.7);
  }
`

export const ResultTableRow = styled(Row)`
  margin-left: 0 !important;
  margin-right: 0 !important;

  .ant-col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`

export const ResultsTable = styled.div((props) => {
  const { hasSidebar } = props
  return stylesIf(
    hasSidebar,
    `
    flex: 1;
    min-width: 0;

    .paged-table {
      width: 100%;
      max-width: 100%;
      & .chec-table {
        width: 100%;
      }
    }
  `
  )
})

const HEADER_FOOTER_OFFSET = 280

export const AdvancedSearchWrap = styled.div`
  min-height: calc(100vh - ${HEADER_FOOTER_OFFSET}px);
`

export const SearchBoxChipFilterArea = styled.div`
  display: flex;
  flex-direction: column;
  width: ${SEARCH_SIDEBAR_WIDTH}px;
`

export const AdvancedSearchArea = styled.div((props) => {
  const { isHorizontalLayout } = props
  const addFeatureStyle = `
    display: flex;
    flex-direction: row;
  `
  return `
    margin-top: 16px;
    ${stylesIf(isHorizontalLayout, addFeatureStyle)}
  `
})

export const AdvancedSearchCard = styled.div`
  width: 326px;
`

export const SearchBoxChipFilterCard = styled.div`
  width: 379px;
`

export const SearchBoxChipFilterCol = styled.div`
  width: 392px !important;
  max-width: 392px !important;
  display: flex;

  .ant-row-flex {
    padding: 0 !important;
    margin: 0 0 8px !important;
  }

  .ant-col {
    padding: 0 !important;
    margin: 0 !important;
  }

  .ant-row-flex:nth-of-type(2) {
    width: auto !important;
  }

  .ant-col label {
    width: 57px;
  }

  .filter-item-container {
    justify-content: flex-start;
  }
`

export const AdvancedSearchCol = styled.div`
  width: 352px !important;
  max-width: 352px !important;
  display: flex;
  border-left: 1px solid ${themeColor('grey')};
  border-right: 1px solid ${themeColor('grey')};
  justify-content: center;
  padding: 0 16px;

  .ant-select {
    width: 100% !important;
  }
`

export const AdvancedChipsCol = styled.div`
  width: 447px !important;
  max-width: 447px !important;
  display: flex;
  flex-direction: column;
  padding: 0 0 0 16px;
`

export const StyledBusCheckboxFilter = styled(Checkbox)`
  margin-top: 15px;
`

export const FastFeaturesFiltersRow = styled(Flex)`
  margin: 25px 0;
  gap: 8px;
  align-items: center;
  justify-content: center;
  & .ant-divider-vertical {
    height: 52.4px !important;
  }
`

export const FastFeaturesFilterArea = styled.div`
  width: fit-content;
  margin: 0 auto;

  & .add-feature-chip-filters {
    margin-left: 0;
    width: 400px;
  }

  & .add-feature-chip-filters .ant-collapse-content-box {
    padding: 0;
  }

  & .add-feature-chip-filters .ant-collapse-content-box > div {
    padding-left: 0;
  }

  &&
    .add-feature-chip-filters.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    padding-left: 0 !important;
  }

  &&
    .add-feature-chip-filters.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    left: 50px !important;
  }

  & .filter-item-container {
    justify-content: flex-start;
  }
`

export const SwitchFilterMenu = styled.div`
  width: 225px;
  & .switch-number-filter-menu,
  & .ant-select {
    width: 100%;
  }
`

export const SwitchCurrentMenu = styled.div`
  width: 140px;
  & .switch-number-filter-menu,
  & .ant-select {
    width: 100%;
  }
`
